export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATETIMEPERIOD_FORMAT = 'YYYY-M-D hh:m a';
export const DATETIMEPERIOD_FORMAT_FULL = 'YYYY-M-D hh:mm A';
export const TIME_FORMAT = 'HH:mm';
export const FORMAT_TYPES = {
  agent: 'agent',
  batteryLevel: 'batteryLevel',
  city: 'city',
  country: 'country',
  creditCardNumber: 'creditCardNumber',
  cvc: 'cvc',
  date: 'date',
  dateOfBirth: 'dateOfBirth',
  dateTime: 'dateTime',
  dealershipDepartment: 'dealershipDepartment',
  distance: 'distance',
  email: 'email',
  fuelDelta: 'fuelDelta',
  fuelLevel: 'fuelLevel',
  genericWithAction: 'genericWithAction',
  insuranceNumber: 'insuranceNumber',
  isoDate: 'isoDate',
  licenseNumber: 'licenseNumber',
  link: 'link',
  note: 'note',
  number: 'number',
  odometer: 'odometer',
  phone: 'phone',
  province: 'province',
  resetOnly: 'resetOnly',
  shortDateTime: 'shortDateTime',
  text: 'text',
  time: 'time',
  undefined: 'undefined',
  postalCode: 'postalCode',
  voltage: 'voltage',
  volume: 'volume',
  zipCode: 'zipCode',
  zipOrPostalCode: 'zipOrPostalCode',
};
